<template>
  <table class="mb2 table-dashboard" width="100%">
    <thead>
      <tr>
        <!-- <td>No Hm</td> -->
        <td>Kod Akaun</td>
        <td>Butiran</td>
        <td>Amaun Debit</td>
        <td>Amaun Kredit</td>
      </tr>
    </thead>
    <tbody>
        <tr>
            <td colspan="4"><center><b>Cukai Tanah Semasa</b></center></td>
        </tr>
        <tr v-for="cuak in shm.cukai">
          <td
            v-if="parseFloat(cuak.tahun) == newYear"
            style="text-align: left"
          >
            {{ cuak.kod_hasil }}
          </td>
          <td
            v-if="parseFloat(cuak.tahun) == newYear"
            style="text-align: left"
          >
            {{ cuak.keterangan }}
          </td>
          <td
            v-if="parseFloat(cuak.tahun) == newYear"
            style="text-align: right"
          >
            {{ moneyFormat(cuak.amaun_debit) }}
          </td>
          <td
            v-if="parseFloat(cuak.tahun) == newYear"
            style="text-align: right"
          >
            {{ moneyFormat(cuak.amaun_kredit) }}
          </td>
        </tr>
      <tr>
            <td colspan="4"><center><b>Cukai Pelarasan</b></center></td>
      </tr>
      <tr v-for="cua in shm.pelarasan" v-if="shm.pelarasan.length!=0">
        <!-- <td  style="text-align: left">
          {{ this.shm.no_hm }}
        </td> -->
        <td  style="text-align: left">
          {{ cua.kodAkaun }}
        </td>
        <td  style="text-align: left">
          {{ cua.keterangan }}
        </td>
        <td  style="text-align: right">
          {{ cua.amaunDebit ? moneyFormat(cua.amaunDebit) : 0 }}
        </td>
        <td  style="text-align: right">
          {{ cua.amaunKredit ? moneyFormat(cua.amaunKredit) : 0 }}
        </td>
      </tr>
      <tr v-else>
        <td colspan="4">
            <div class="w-card__content content-hardcode">
                <center>Tiada Pelarasan Dibuat</center>
            </div>
        </td>
      </tr>
      <tr>
        <td colspan="4"><center><b>Resit Bayaran</b></center></td>
      </tr>
      <tr v-for="bayar in shm.terimaan" >
            <td   v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'">No Resit : {{ bayar.no_resit }}</td>
            <td align="right"  v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'"></td>
            <td align="right"  v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'">0.00</td>
            <td align="right"  v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'">{{ Number(bayar.amaun ).toFixed(2)}}</td>
      </tr>
      <tr v-if="this.shm.total">
        <td colspan="2"><b>JUMLAH</b></td>
        <td align="right"><b>{{this.shm.debit}}</b></td>
        <td align="right"><b>{{this.shm.kredit}}</b></td>
      </tr>
      <tr v-if="this.shm.total">
        <td colspan="2" ><b>Amaun Debit - Amaun Kredit</b></td>
        <td colspan="2" align="right"><b>{{this.shm.total}}</b></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import WaveUI from "wave-ui";
  import { moneyFormat } from "../../helper/index.js";
export default {
  components: {},
  props: {
    shm: [Array, Object],
  },
  data() {
    return {
      waveui: new WaveUI(),
      valid: null,
      validators: {
        required: (value) => !!value || "Sila Isi Ruangan Ini",
      },
      apiBaseUrl: process.env.MIX_API_BASE_URL,
      loading: false,

      error: null,
    };
  },
  computed: {
    newYear() {
      // const y
      const d = new Date();
      let c = d.getFullYear();

      return c;
    },
  },
  methods:{
    moneyFormat,
  }
};
</script>
